"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _a, _b, _c;
exports.Order = { DESC: 'DESC', ASC: 'ASC' };
exports.FilterOperation = {
    EQ: 'EQ',
    NEQ: 'NEQ',
    GT: 'GT',
    LT: 'LT',
    GTE: 'GTE',
    LTE: 'LTE',
    STARTWITH: 'STARTWITH',
    ENDWITH: 'ENDWITH',
    CONTAINS: 'CONTAINS',
    IS_NULL: 'IS_NULL',
    NOT_NULL: 'NOT_NULL',
};
exports.ColumnType = {
    TEXT: 'ColumnType.TEXT',
    BOOLEAN: 'ColumnType.BOOLEAN',
    ENUM: 'ColumnType.ENUM',
    REMOTE_ENUM: 'ColumnType.REMOTE_ENUM',
    NUMBER: 'ColumnType.NUMBER',
    TEXT_NUMBER: 'ColumnType.TEXT_NUMBER',
    DATETIME: 'ColumnType.DATETIME',
    DATETIMEWITHOUTZONE: 'ColumnType.DATETIMEWITHOUTZONE',
    DATE: 'ColumnType.DATE',
    TIME: 'ColumnType.TIME',
    JSX: 'ColumnType.JSX',
};
exports.defaultFilterOperation = (_a = {},
    _a[exports.ColumnType.TEXT] = exports.FilterOperation.CONTAINS,
    _a[exports.ColumnType.BOOLEAN] = exports.FilterOperation.EQ,
    _a[exports.ColumnType.ENUM] = exports.FilterOperation.EQ,
    _a[exports.ColumnType.REMOTE_ENUM] = exports.FilterOperation.EQ,
    _a[exports.ColumnType.NUMBER] = exports.FilterOperation.EQ,
    _a[exports.ColumnType.TEXT_NUMBER] = exports.FilterOperation.CONTAINS,
    _a[exports.ColumnType.DATETIME] = exports.FilterOperation.EQ,
    _a[exports.ColumnType.DATETIMEWITHOUTZONE] = exports.FilterOperation.EQ,
    _a[exports.ColumnType.DATE] = exports.FilterOperation.EQ,
    _a[exports.ColumnType.TIME] = exports.FilterOperation.EQ,
    _a[exports.ColumnType.JSX] = exports.FilterOperation.CONTAINS,
    _a);
exports.filterTranslations = (_b = {},
    _b[exports.FilterOperation.EQ] = 'rovná se',
    _b[exports.FilterOperation.NEQ] = 'nerovná se',
    _b[exports.FilterOperation.GT] = 'je větší',
    _b[exports.FilterOperation.LT] = 'je menší',
    _b[exports.FilterOperation.GTE] = 'je větší nebo rovno',
    _b[exports.FilterOperation.LTE] = 'je menší nebo rovno',
    _b[exports.FilterOperation.STARTWITH] = 'začíná s',
    _b[exports.FilterOperation.ENDWITH] = 'končí s',
    _b[exports.FilterOperation.CONTAINS] = 'obsahuje',
    _b[exports.FilterOperation.IS_NULL] = 'je prázdné',
    _b[exports.FilterOperation.NOT_NULL] = 'není prázdné',
    _b);
exports.filterTranslationsEn = {
    EQ: 'Equal',
    NEQ: 'Not equal',
    GT: 'Greater',
    LT: 'Less',
    GTE: 'Greater or equal',
    LTE: 'Less or equal',
    STARTWITH: 'Starts with',
    ENDWITH: 'Ends with',
    CONTAINS: 'Contains',
};
exports.TrueFalse = [{ id: true, label: 'Ano' }, { id: false, label: 'Ne' }];
exports.TrueFalseEn = [{ id: true, label: 'Yes' }, { id: false, label: 'No' }];
exports.filterOperations = (_c = {},
    _c[exports.ColumnType.NUMBER] = [
        exports.FilterOperation.EQ,
        exports.FilterOperation.NEQ,
        exports.FilterOperation.GT,
        exports.FilterOperation.LT,
        exports.FilterOperation.GTE,
        exports.FilterOperation.LTE,
    ],
    _c[exports.ColumnType.TEXT] = [
        exports.FilterOperation.EQ,
        exports.FilterOperation.NEQ,
        exports.FilterOperation.STARTWITH,
        exports.FilterOperation.ENDWITH,
        exports.FilterOperation.CONTAINS,
    ],
    _c[exports.ColumnType.TEXT_NUMBER] = [
        exports.FilterOperation.EQ,
        exports.FilterOperation.NEQ,
        exports.FilterOperation.STARTWITH,
        exports.FilterOperation.ENDWITH,
        exports.FilterOperation.CONTAINS,
        exports.FilterOperation.GT,
        exports.FilterOperation.LT,
        exports.FilterOperation.GTE,
        exports.FilterOperation.LTE,
    ],
    _c[exports.ColumnType.DATE] = [
        exports.FilterOperation.EQ,
        exports.FilterOperation.NEQ,
        exports.FilterOperation.GT,
        exports.FilterOperation.LT,
        exports.FilterOperation.GTE,
        exports.FilterOperation.LTE,
    ],
    _c[exports.ColumnType.DATETIMEWITHOUTZONE] = [
        exports.FilterOperation.EQ,
        exports.FilterOperation.NEQ,
        exports.FilterOperation.GT,
        exports.FilterOperation.LT,
        exports.FilterOperation.GTE,
        exports.FilterOperation.LTE,
    ],
    _c[exports.ColumnType.DATETIME] = [
        exports.FilterOperation.EQ,
        exports.FilterOperation.NEQ,
        exports.FilterOperation.GT,
        exports.FilterOperation.LT,
        exports.FilterOperation.GTE,
        exports.FilterOperation.LTE,
    ],
    _c[exports.ColumnType.JSX] = [],
    _c[exports.ColumnType.BOOLEAN] = [exports.FilterOperation.EQ],
    _c[exports.ColumnType.ENUM] = [exports.FilterOperation.EQ],
    _c[exports.ColumnType.REMOTE_ENUM] = [exports.FilterOperation.EQ],
    _c);
exports.aggregationOptions = [
    {
        id: 'AND',
        label: 'a',
    },
    {
        id: 'OR',
        label: 'nebo',
    },
];
//# sourceMappingURL=constants.js.map


//////////////////
// WEBPACK FOOTER
// .-core/es/components/controls/Grid/constants.js
// module id = 31
// module chunks = 0